// 公共配置文件
export const IMAGE_BASE_URL = "http://101.35.126.37:8081/api/app";

// 接口密钥配置
export const interface_pubkey =
  "0405790f782a05211783740d939df9b4ce2ba80efd306dcc4a3f1305359e24056a060f61edb57838ae713dac85badc23cc27c55247685f6f754a390b03c7a91b71";
export const interface_prikey =
  "00e64c576231d7898b1fdf0817d31a2c3687390ded0c2d81e787301b95fa167171";
export const app_key =
  "79220a8a7764c35994910267c1022953188384857e5f321cc4b8c6274215dad4";
export const interface_pubkey1 =
  "04184b1b31eb2842fec9b888ff5136811407e10489d0fc618a082afdb9c1f5acab4a76e195b5b70b84f44fb8a3d7e944d8f520d8f47a4fd932fdc09524110424c3";
export const interface_prikey1 =
  "5c6dc1c9fbed27b4efaf816f3260b92edad5b84cf5c911a69821ae678d05294d";
// true为爱山东app，false为浏览器
export const appOrPC = true;
// "1"为生产，"2"为测试
export const ipType = "2";
// 生产环境图片地址http://112.6.228.172:18081，测试环境图片地址http://101.35.126.37:8081；
export const IMAGE_URL = "http://101.35.126.37:8081/api/app/common/image";
